import type { Resource } from '../../';
export const product_sizeChart_category_men: Resource = {"default":"Men"};
